import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from 'components/common/Icon/Icon'
import Link from 'components/common/Link/Link'

const Location = ({ storeAddress1, storeCity, storeState, storeZip, storePhone, storeDetailsUrl }) =>
  <Wrapper>
    <Address>{ storeAddress1 }<br />{ storeCity } { storeState } { storeZip }</Address>
    <PhoneWrapper>
      <Icon asset="phone" width={ 10 } height={ 10 } />
      <Phone>{ storePhone }</Phone>
    </PhoneWrapper>
    <StoreDetails to={ storeDetailsUrl }>Store Details</StoreDetails>
  </Wrapper>

Location.propTypes = {
  storeAddress1: PropTypes.string,
  storeCity: PropTypes.string,
  storeDetailsUrl: PropTypes.string,
  storePhone: PropTypes.string,
  storeState: PropTypes.string,
  storeZip: PropTypes.string
}

export default Location

const Wrapper = styled.div`
  background-color: #fff;
  padding: 10px;
  border: 1px solid #ccc;
`

const PhoneWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`

const Address = styled.p`
  margin: 0 0 30px;
`

const Phone = styled.p`
  margin: 0 0 0 5px;
`

const StoreDetails = styled(Link)``
